import { applyOverrides, buildClientCard } from '../../../shared';

const baseCard = buildClientCard({
  id: 'buySideContacts.buyersX',
  entityType: 'counterpartyClient',
  label: 'Tenant',
  showSameAsProperty: false,
  requireNameAndEmail: true,
});

export const buyerCard = applyOverrides(baseCard, {
  layout: [
    [
      {
        name: 'contacts.counterpartyClient.x.firstName',
        size: 33,
        mobileSize: 50,
      },
      {
        name: 'contacts.counterpartyClient.x.lastName',
        size: 33,
        mobileSize: 50,
      },
      {
        name: 'contacts.counterpartyClient.x.nickname',
        size: 34,
        mobileSize: 100,
      },
    ],
    ...baseCard.layout.slice(1),
  ],
  fields: {
    nickname: {
      name: 'contacts.counterpartyClient.x.nickname',
      entity: 'contacts',
      entityType: 'counterpartyClient',
      type: 'text',
      label: 'Nickname',
    },
    isSelfRepresented: {
      name: 'contacts.counterpartyClient.x.isSelfRepresented',
      entity: 'contacts',
      entityType: 'counterpartyClient',
      type: 'hidden',
      label: 'Tenant is self-represented',
    },
    powerOfAttorneyEmail: {
      validation: [
        {
          type: 'email',
          message: 'Invalid email',
        },
        {
          type: 'required',
          message: 'Required',
        },
      ],
    },
  },
});
